import styles from './ProgressBar.module.scss';

const ProgressBar = ({ percentage, labels }) => {
    return (
        <div className={`mx-auto py-2 ${styles.progressBarContainer}`}>
            <div className={styles.barContainer}>
                <div className={`h-100 ${styles.progressFill}`} style={{ width: `${percentage}%` }} />
            </div>
            <div className="d-flex mt-2">
                {labels.map((label, index) => (
                    <div
                        key={index}
                        className={`flex-fill text-center border-end ${index === 0 ? 'border-start' : ''} border-3 border-dark-subtle py-1`}>
                        <div className={styles.label}>{label}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProgressBar;
